import { render, staticRenderFns } from "./MemoriesPage.vue?vue&type=template&id=6f706f44&scoped=true&"
import script from "./MemoriesPage.vue?vue&type=script&lang=js&"
export * from "./MemoriesPage.vue?vue&type=script&lang=js&"
import style0 from "./MemoriesPage.vue?vue&type=style&index=0&id=6f706f44&lang=scss&scoped=true&"
import style1 from "./MemoriesPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f706f44",
  null
  
)

export default component.exports